//  Controller Scenes
//
// Work in progress
// => Phase 2
//ModalService


angular.module('app.controllers.menuentryItem', [])

    .controller("MenuEntryItemCtrl", ['$scope', '$rootScope', '$state','xcenterUtils','selectIconModal','xCenterConfig','API','__MenuEntry','$log',
        function ($scope, $rootScope, $state ,xcenterUtils,selectIconModal,xCenterConfig,API,__MenuEntry,$log) {

            var customActions = xCenterConfig.customActions;
            $scope.goTo = function (MenuEntry, DeviceId) {
                var stateParams = {'menuEntryId': MenuEntry.MenuEntryId, 'deviceId': DeviceId,menuEntry : MenuEntry};
                var state = 'device.entry';
                if (MenuEntry.MenuEntryType == 3) {
                    // Custom Action. check if it exists.
                    if (customActions.hasOwnProperty(MenuEntry.CustomActionName)) {

                        if (!customActions[MenuEntry.CustomActionName].active) {
                            $log.info(`Custom action ${MenuEntry.CustomActionName} is not activated!`);
                            return;
                        }

                        if (MenuEntry.CustomActionName === 'ChangeLanguage') {
                            $rootScope.$broadcast('showLanguageMenu');
                            return;
                        }

                        // Check for Modal
                        var modal = customActions[MenuEntry.CustomActionName].modal;
                        if(modal){
                            switch(modal){
                                case "userLevelLogin":

                                    break;
                            }
                            return;
                        }

                        state = customActions[MenuEntry.CustomActionName].state;

                        stateParams = angular.extend(stateParams, customActions[MenuEntry.CustomActionName].stateParams);

                    } else {
                        state = 'device.entry';
                    }
                }
                $rootScope.deviceEntry = MenuEntry.DisplayName;
                $state.go(state, stateParams);
            };

            $scope.$save = function (MenuEntry) {
                MenuEntry.$UI.loading = false;
                MenuEntry.$save().$then(function () {
                    MenuEntry.$UI.loading = false;
                })
            };

            $scope.markForDelete = function (MenuEntry, event) {
                event.stopPropagation();
                MenuEntry.$UI.markForDelete = true;
            };

            $scope.clickMenuEntry = function (MenuEntry, $UI, event) {
                if ($UI.editMode == true) {
                    if ($UI.editItemBefore && $UI.editItem && xcenterUtils.wasEdited($UI.editItemBefore, $UI.editItem, ['DisplayName', 'ImageName', 'Sort', 'ParentMenuEntryId'])) {
                        $UI.editItem.$UI.changed = true;
                    }
                    if ($UI.editItem != undefined && $UI.editItem.MenuEntryId != MenuEntry.MenuEntryId) {

                        $UI.editItem.$UI.editMode = false;
                    }
                    if (MenuEntry.$UI.editMode == true) {
                        MenuEntry.$UI.editMode = false;
                    } else {
                        MenuEntry.$UI.editMode = true;
                        $UI.editItem = MenuEntry;
                        $UI.editItemBefore = angular.copy(MenuEntry);
                    }
                } else {
                    $scope.goTo(MenuEntry, MenuEntry.DeviceId);
                }

            }

            $scope.hasWindowOpen = function(list)
            {
                for(var i = 0; i < list.length; i++)
                {
                    if(list[i].DatapointValue.Value === false)
                    {
                        return true;
                    }
                }
                return false;
            }
            $scope.hasActivePlugActive = function(list)
            {
                for(var i = 0; i < list.length; i++)
                {
                    if(list[i].DatapointValue.Value === true)
                    {
                        return true;
                    }
                }
                return false;
            }
            $scope.deleteItem = function(item,list){

                var _API = new API();
                var i = __MenuEntry.$buildRaw(item);
                i.$destroy().$then(function(){
                    list.splice(list.indexOf(item),1);
                })
            }
            $scope.changeIcon = function (MenuEntry, $UI, event) {

                if (!MenuEntry.$UI.editMode) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                selectIconModal(MenuEntry.ImageName).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            MenuEntry.ImageName = data;
                            $scope.$broadcast('ImageNameChanged');
                        }
                    });
                });
            };


        }

    ]);
